var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8984 11.75L11.4453 8.15625H7.96875V5.8125C7.96875 4.79688 8.4375 3.85938 10 3.85938H11.6016V0.773438C11.6016 0.773438 10.1562 0.5 8.78906 0.5C5.9375 0.5 4.0625 2.25781 4.0625 5.38281V8.15625H0.859375V11.75H4.0625V20.5H7.96875V11.75H10.8984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebookIcon);
export default __webpack_public_path__ + "static/media/footer_facebook_Icon.0cc2ace4671dc36f43b2cc7d94a9b7af.svg";
export { ForwardRef as ReactComponent };